`/** * @Description: 新增素材页 * @author zhaijiayu * @date 2021/8/25 */
<template>
  <div class="material-add-container">
    <!--    面包屑导航-->
    <section class="page-nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/material/1' }"
          >素材</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/material/0' }"
          >我的素材</el-breadcrumb-item
        >
        <el-breadcrumb-item>上传素材</el-breadcrumb-item>
      </el-breadcrumb>
    </section>
    <!--    素材图片编辑区-->
    <section class="source-edit-area">
      <span class="label required" style="transform: translateX(-40px)"></span>
      <div
        class="source-item-container"
        v-for="(source, index) in editData.sourceList"
        :key="source.sourceUrl"
      >
        <el-image class="source-item" :src="source.coverUrl" fit="fill" />
        <div class="action-bar">
          <el-button
            type="error"
            class="action-btn del"
            @click="handleDeleteSource(index)"
            >删除</el-button
          >
          <!--          <span type="info" class="action-btn opt">优化</span>-->
        </div>
      </div>
      <!--      素材上传按钮-->
      <el-upload
        :action="uploadAction"
        :accept="supportMIME"
        :show-file-list="false"
        :before-upload="handleBeforeUpload"
      >
        <i class="el-icon-plus upload-btn" />
      </el-upload>
    </section>
    <!--    标题-->
    <section class="title edit-area-container">
      <span class="label required">素材名称:</span>
      <el-input
        v-model="editData.title"
        type="text"
        maxlength="30"
        show-word-limit
        class="edit-area title"
        placeholder="请输入标题"
      />
    </section>
    <!--    描述-->
    <section class="edit-area-container desc">
      <span class="label required">素材描述:</span>
      <el-input
        v-model="editData.desc"
        type="textarea"
        class="edit-area"
        maxlength="400"
        show-word-limit
        placeholder="请输入描述内容"
        resize="none"
      />
    </section>
    <!--    标签-->
    <section class="edit-area-container">
      <span class="label">标签:</span>
      <el-select
        class="edit-area tag"
        v-model="editData.tagList"
        multiple
        filterable
        allow-create
        :remote="true"
        placeholder="请输入关键字来搜索标签"
        :remote-method="handleTagSearch"
      >
        <el-option
          v-for="item in tagList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </section>
    <footer class="footer">
      <el-button type="error" @click="cancelEdit">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </footer>

    <div class="tinymce-upload-progress-box" v-show="isUploading">
      <el-progress
        class="tinymce-upload-progress"
        type="circle"
        :percentage="progressPercent"
      ></el-progress>
    </div>

    <div class="uploadVideoBg" v-show="isUploading"></div>
  </div>
</template>
<script>
import { RESOURCE_HOST } from "../../constants/apiHosts";
import { UPLOAD_SUPPORT_MIME, DEFAULT_COVER } from "../../constants/manuscript";
import { HS_upload } from "./../../utils/huoshanUpload";

export default {
  name: "materialEdit",
  computed: {
    uploadAction: function () {
      return ``;
    },
    supportMIME: function () {
      return UPLOAD_SUPPORT_MIME.join(",");
    },
  },
  data: function () {
    return {
      tagList: [],
      editData: {
        title: "",
        desc: "",
        // 上传的资源链接列表
        sourceList: [],
        tagList: [],
      },
      progressPercent: 0,
      isUploading: false,
    };
  },
  methods: {
    /**
     * 筛选标签
     * @param keywords {string} 关键字
     * @returns {Promise<void>}
     */
    handleTagSearch: async function (keywords) {
      console.log(keywords, "tagSearchKeywords");
      if (keywords === "") {
        this.tagList = [];
        return;
      }
      try {
        const { data } = await this.$axios(`${RESOURCE_HOST}/api/label/list`, {
          method: "post",
          data: {
            name: keywords,
          },
        });
        const list = data.data.data ?? [];
        this.tagList = list.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
      } catch (e) {
        console.error(e);
      }
    },
    handleBeforeUpload: function (event) {
      if (event.type.indexOf("image/") < 0) {
        this.$message({
          message: "请上传图片素材",
          type: "warning",
        });
        return;
      }

      this.uploadProgress(true);

      HS_upload(
        event,
        (data) => {
          console.log(data);
          let sourceUrl = "";
          let coverUrl = DEFAULT_COVER;

          if (event.type.indexOf("image/") >= 0) {
            sourceUrl = data.url;
            coverUrl = sourceUrl;
          } else if (event.type.indexOf("video/") >= 0) {
            sourceUrl = data.videoUri;
            coverUrl = data.PosterUri;
          }

          this.editData.sourceList = [
            ...this.editData.sourceList,
            {
              sourceUrl: sourceUrl,
              coverUrl: coverUrl,
            },
          ];

          this.uploadProgress(false);
        },
        (error) => {
          console.log(error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
          this.progressPercent = processPercent;
        }
      );
    },
    uploadProgress: function (show) {
      let dialog = $(".tinymce-upload-progress-box");
      let progress = $(".tinymce-upload-progress");
      let progressBar = $('<div class="progress-bar"></div>');
      let sourceBox = $(".tinymce-upload-progress-box");
      if (show) {
        this.progressPercent = 0;
        this.isUploading = true;
        progressBar.append(progress);
        dialog.append(progressBar);
        progress.show();
      } else {
        this.isUploading = false;
        progress.hide();
        sourceBox.append(progress);
        progressBar.remove();
      }
    },
    /**
     * 删除指定图片
     * @param idx {number} 素材位置
     */
    handleDeleteSource: function (idx) {
      let sourceList = [...this.editData.sourceList];
      sourceList.splice(idx, 1);
      this.editData.sourceList = sourceList;
    },
    /**
     * 校验编辑的数据
     * @returns {boolean}
     */
    validateEditData: function () {
      const { title, desc } = this.editData;
      if (title === "") {
        this.$message.error("素材名称不能为空");
        return false;
      }
      if (desc === "") {
        this.$message.error("素材描述不能为空");
        return false;
      }
      if (desc.length > 400) {
        this.$message.error("素材描述超出长度限制");
      }
      return true;
    },
    /**
     * 确认提交
     * @return {Promise<void> | boolean}
     */
    handleSubmit: async function () {
      if (!this.validateEditData()) return false;
      // 处理资源列表
      const coverList = this.editData.sourceList.map((item) => item.coverUrl);
      const sourceList = this.editData.sourceList.map((item) => item.sourceUrl);
      try {
        const { data } = await this.$axios(
          `${RESOURCE_HOST}/api/material/save`,
          {
            method: "POST",
            data: {
              files: sourceList.join(","),
              covers: coverList.join("|"),
              title: this.editData.title,
              labels: this.editData.tagList.join(","),
              describe: this.editData.desc,
            },
          }
        );
        if (data.code == 0) {
          this.$message.success("添加素材成功");
          this.cancelEdit();
        } else {
          if (data.data || data.msg) {
            this.$message.error(data.data ?? data.msg);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 取消编辑
     */
    cancelEdit: function () {
      this.$router.push({ name: "material" });
    },
  },
};
</script>
<style lang="scss" scoped>
// 图片展示宽度
$sourceWidth: 200px;
// 图片展示高度
$sourceHeight: 200px;
.material-add-container {
  margin: 20px 150px;
  .page-nav {
    margin: 10px 0px 30px -130px;
  }
  .source-edit-area {
    padding: 20px 10px;
    background: #ffffff;
    display: flex;
    flex-wrap: wrap;

    .upload-btn {
      height: $sourceHeight;
      width: $sourceWidth;
      border: 1px dashed #409eff;
      font-size: 30px;
      line-height: $sourceHeight;
      text-align: center;
      color: #8c939d;
      margin: 10px;
    }
    .source-item-container {
      width: $sourceWidth;
      height: $sourceHeight;
      margin: 10px;
      overflow: hidden;
      position: relative;
      border: 3px solid #ebeef5;

      .source-item {
        width: 100%;
        height: 100%;
      }
      .action-bar {
        position: absolute;
        left: 0;
        bottom: -40px;
        height: 40px;
        width: 100%;
        display: flex;
        transition: bottom 0.5s;
        line-height: 40px;

        .action-btn {
          flex: 1;
          text-align: center;
          cursor: pointer;
          margin: 0 3px;
          border-radius: 5px;
        }
        .action-btn.del {
          border: 1px solid #f56c6c;
          color: #f56c6c;
        }
        .action-btn.opt {
          //border: 1px solid #67C23A;
          //color: #67C23A;
        }
      }
    }
    .source-item-container:hover {
      .action-bar {
        bottom: 0;
      }
    }
  }
  .edit-area-container {
    display: flex;
    align-items: center;
    margin: 10px 0;
    .label {
      display: inline-block;
      width: 100px;
      margin-left: -120px;
      text-align: right;
    }
    .edit-area {
      margin: 0 0 0 20px;
    }
    .edit-area.title {
      /deep/.el-input__inner {
        text-align: center;
      }
    }
    .edit-area.tag {
      width: 250px;
      /deep/.el-select__tags .el-tag {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 18px;
        position: relative;

        .el-tag__close {
          position: absolute;
          right: 2px;
          top: 5px;
        }
      }
    }
  }
  .desc {
    align-items: flex-start;
    .edit-area {
      /deep/.el-textarea__inner {
        height: 100px;
      }
    }
  }
  .footer {
    .el-button {
      width: 150px;
      margin: 20px 20px 0 0;
    }
  }
  .tinymce-upload-progress {
    position: absolute !important;
    text-align: center;
    display: none;
    top: 50%;
    left: 50%;
    margin-top: -62px !important;
    margin-left: -60px !important;
    z-index: 2;
  }
  .uploadVideoBg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.75);
    z-index: 1;
  }
}
</style>
